<app-crud-edit [apiService]="establecimientosService" [fields]="fields" [title]="'establecimiento'" [description]="'En esta sección podrás editar el detalle del Establecimiento'"></app-crud-edit>
